import { render } from "./Monitoramento.vue?vue&type=template&id=efdbbf20"
import script from "./Monitoramento.vue?vue&type=script&lang=js"
export * from "./Monitoramento.vue?vue&type=script&lang=js"

import "./Monitoramento.vue?vue&type=style&index=0&id=efdbbf20&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__